import {filter, find} from "lodash/collection"
import {isEqual} from "lodash/lang"

export const PROCESSING_MIN_ZOOM = 12
export const PROCESSING_MAX_ZOOM = 21

export const PROCESSING_TYPES = {
  FULL_PROCESSING: "FULL_PROCESSING",
  TILLING: "TILLING",
  SATELLITE: "SATELLITE",
}

export const PROCESSING_TEMPLATES = {
  PADRAO_RGB: "PADRAO_RGB",
  AGRICOLA_RGB: "AGRICOLA_RGB",
  // TOPOGRAFIA_RGB: "TOPOGRAFIA_RGB",
  SILVICULTURA_RGB: "SILVICULTURA_RGB",
  AGRICOLA_MULTISPECTRAL: "AGRICOLA_MULTISPECTRAL",
  PADRAO_3D: "PADRAO_3D",
}

export const GEOREFERENCE_TYPES = {
  NOT_SET: "NOT_SET",
  LAT_LONG: "LAT_LONG",
  LONG_LAT: "LONG_LAT",
  THREE_D_ROBOTICS: "THREE_D_ROBOTICS",
}

export const PROCESSING_STATUS = {
  CREATED: "CREATED",
  READY_TO_UPLOAD: "READY_TO_UPLOAD",
  READY_TO_PAY: "READY_TO_PAY",
  WAITING_PAYMENT: "WAITING_PAYMENT",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  PAID: "PAID",
  ON_QUEUE: "ON_QUEUE",
  PROCESSING: "PROCESSING",
  PROCESSING_MANUAL: "PROCESSING_MANUAL",
  ERROR: "ERROR",
  ENDED: "ENDED",
  WAITING_ADD_GCP: "WAITING_ADD_GCP",
  DEBUG_PAID: "DEBUG_PAID",
  ARCHIVED: "ARCHIVED",
  UNARCHIVING: "UNARCHIVING",
  REPROCESS_REQUESTED: "REPROCESS_REQUESTED"
}

export const PROCESSING_STATUS_DETAILS = [
  {
    name: "Processamento criado",
    value: PROCESSING_STATUS.CREATED,
    icon: "mdi-plus-box",
    color: "primary",
    class: "",
  },
  {
    name: "Upload disponível",
    value: PROCESSING_STATUS.READY_TO_UPLOAD,
    icon: "mdi-cloud-upload",
    color: "accent",
    class: "",
  },
  {
    name: "Disponível no carrinho",
    value: PROCESSING_STATUS.READY_TO_PAY,
    icon: "mdi-cart-arrow-right",
    color: "accent",
    class: "",
  },
  {
    name: "Aguardando pagamento",
    value: PROCESSING_STATUS.WAITING_PAYMENT,
    icon: "mdi-cash",
    color: "yellow",
    class: "",
  },
  {
    name: "Erro no pagamento",
    value: PROCESSING_STATUS.PAYMENT_ERROR,
    icon: "mdi-alert-circle",
    color: "error",
    class: "",
  },
  {
    name: "Pago",
    value: PROCESSING_STATUS.PAID,
    icon: "mdi-receipt",
    color: "success",
    class: "",
  },
  {
    name: "Na fila",
    value: PROCESSING_STATUS.ON_QUEUE,
    icon: "mdi-history",
    color: "",
    class: "",
  },
  {
    name: "Processando",
    value: PROCESSING_STATUS.PROCESSING,
    icon: "mdi-sync",
    color: "",
    class: "spinning",
  },
  {
    name: "Processando",
    value: PROCESSING_STATUS.PROCESSING_MANUAL,
    icon: "mdi-sync",
    color: "",
    class: "spinning",
  },
  {
    name: "Erro inesperado",
    value: PROCESSING_STATUS.ERROR,
    icon: "mdi-alert",
    color: "warning",
    class: "",
  },
  {
    name: "Processamento finalizado",
    value: PROCESSING_STATUS.ENDED,
    icon: "mdi-check-circle",
    color: "success",
    class: "processing-ended",
  },
  {
    name: "Processando",
    value: PROCESSING_STATUS.WAITING_ADD_GCP,
    icon: "mdi-sync",
    color: "",
    class: "spinning",
  },
  // {
  //   name: "Aguardando adição de GCP",
  //   value: PROCESSING_STATUS.WAITING_ADD_GCP,
  //   icon: "mdi-map-marker-plus",
  //   color: "info",
  //   class: ""
  // },
  {
    name: "Teste DEV",
    value: PROCESSING_STATUS.DEBUG_PAID,
    icon: "mdi-paper-roll",
    color: "purple darken-2",
    class: "",
  },
  {
    name: "Processamento arquivado",
    value: PROCESSING_STATUS.ARCHIVED,
    icon: "mdi-archive",
    color: "",
    class: "",
  }, 
  {
    name: "Desarquivamento solicitado",
    value: PROCESSING_STATUS.UNARCHIVING,
    icon: "mdi-archive-arrow-up",
    color: "",
    class: "",
  },   
  {
    name: "Reprocessamento solicitado",
    value: PROCESSING_STATUS.REPROCESS_REQUESTED,
    icon: "mdi-autorenew",
    color: "warning",
    class: "",
  }, 
]

export const PROCESSING_STATUS_FILTER_LIST = [
  {
    text: "Processamento criado",
    value: PROCESSING_STATUS.CREATED,
  },
  {
    text: "Upload disponível",
    value: PROCESSING_STATUS.READY_TO_UPLOAD,
  },
  {
    text: "Disponível no carrinho",
    value: PROCESSING_STATUS.READY_TO_PAY,
  },
  {
    text: "Aguardando pagamento",
    value: PROCESSING_STATUS.WAITING_PAYMENT,
  },
  {
    text: "Erro no pagamento",
    value: PROCESSING_STATUS.PAYMENT_ERROR,
  },
  {
    text: "Pago",
    value: PROCESSING_STATUS.PAID,
  },
  {
    text: "Na fila",
    value: PROCESSING_STATUS.ON_QUEUE,
  },
  {
    text: "Processando",
    value: [PROCESSING_STATUS.PROCESSING, PROCESSING_STATUS.PROCESSING_MANUAL, PROCESSING_STATUS.WAITING_ADD_GCP],
  },
  {
    text: "Erro inesperado",
    value: PROCESSING_STATUS.ERROR,
  },
  {
    text: "Processamento finalizado",
    value: PROCESSING_STATUS.ENDED,
  },
  {
    text: "Aguardando adição de GCP",
    value: PROCESSING_STATUS.WAITING_ADD_GCP,
  },
  {
    text: "Reprocessamento solicitado",
    value: PROCESSING_STATUS.REPROCESS_REQUESTED,
  },
]

export const PROCESSING_STATUS_CREATED = [
  ...filter(PROCESSING_STATUS, value => !isEqual(value, PROCESSING_STATUS.CREATED)),
]

export const PROCESSING_STATUS_CREATING = [
  PROCESSING_STATUS.CREATED,
]

export const PROCESSING_STATUS_CAN_EDIT_BASIC = [
  PROCESSING_STATUS.CREATED,
  PROCESSING_STATUS.READY_TO_UPLOAD,
  PROCESSING_STATUS.READY_TO_PAY,
]

export const PROCESSING_STATUS_CAN_EDIT_ADVANCED = [
  PROCESSING_STATUS.READY_TO_UPLOAD,
  PROCESSING_STATUS.READY_TO_PAY,
]

export const PROCESSING_STATUS_CAN_EDIT_PROCESSING_TYPE = [
  PROCESSING_STATUS.CREATED,
  PROCESSING_STATUS.READY_TO_UPLOAD,
]

export const PROCESSING_STATUS_READ_ONLY = [
  PROCESSING_STATUS.WAITING_PAYMENT,
  PROCESSING_STATUS.PAID,
  PROCESSING_STATUS.PROCESSING,
  PROCESSING_STATUS.PROCESSING_MANUAL,
  PROCESSING_STATUS.ERROR,
  PROCESSING_STATUS.WAITING_ADD_GCP,
  PROCESSING_STATUS.ON_QUEUE,
  PROCESSING_STATUS.ENDED,
  PROCESSING_STATUS.REPROCESS_REQUESTED
]

export const CAMERA_TYPES = {
  MULTISPECTRAL: "MULTISPECTRAL",
  RGB: "RGB",
}

export const TILLING_CREATE_DATA_DEFAULT = {
  ab_processing_type: PROCESSING_TYPES.TILLING,
  ab_processing_template: PROCESSING_TEMPLATES.DEFAULT,
  ab_camera_type: CAMERA_TYPES.RGB,

  bl_gcp: false,
}

export const PROCESSING_STEPS = {
  BASIC: "1",
  ADVANCED: "2",
  UPLOAD: "3",
  SUMMARY: "4",
  PAYMENT: "5",
  POST_PAYMENT: "6",
}

export const PROCESSING_TYPES_DETAILS = {
  FULL_PROCESSING: {name: "Imagens de Drone", value: "FULL_PROCESSING"},
  TILLING: {name: "Ortomosaico", value: "TILLING"},
}

export const PROCESSING_OPTIONS = {
  abCameraType: [
    {
      value: CAMERA_TYPES.RGB,
      name: "RGB",
      description: {
        titles: ["Descrição", "Exemplos", "Formato das Images"],
        texts: [
          "Câmeras e sensores fotográficos convencionais.",
          "FC6310 (Phantom 4), Canon, Sony.",
          " Imagens em formato <b>JPEG</b> ou <b>PNG</b> com orientação de 90º em relação ao solo.",
        ],
      },
    },
    {
      value: CAMERA_TYPES.MULTISPECTRAL,
      name: "Multiespectral",
      description: {
        titles: ["Descrição", "Exemplos", "Formato das Images"],
        texts: [
          "Sensores especiais que captam luz não visível ao ser humano e transformam essa informação em resultados importantes para o agricultor.",
          "Sequoia e RedEdge", "Imagens em formato <b>TIF</b> com orientação de 90º em relação ao solo.",
        ],
      },
    },
  ],
  abProcessingTemplate: {
    [CAMERA_TYPES.RGB]: [
      {
        value: PROCESSING_TEMPLATES.PADRAO_RGB,
        name: "Urbano",
        description: {
          titles: [
            "Descrição", "Produtos Gerados",
          ],
          texts: [
            "Tipo de processamento para áreas urbanas, por exemplo, que tenham edificações, estradas ou outros tipos de construções.",            
            "<b>Ortomosaico</b>, <b>Modelo Digital de Terreno</b>, <b>Modelo Digital de Superfície</b>, <b>Curvas de nível</b>, <b>nuvem de pontos</b> e <b>modelo 3D</b>.",
          ],
        },
      },
      {
        value: PROCESSING_TEMPLATES.AGRICOLA_RGB,
        name: "Rural",
        description: {
          titles: [
            "Descrição", "Produtos Gerados",
          ],
          texts: [
            "Tipo de processamento para áreas homogêneas, como de produção agrícola anual ou perene.",
            "<b>Ortomosaico</b>, <b>Modelo Digital de Terreno</b>, <b>Modelo Digital de Superfície</b>, <b>Curvas de nível</b>, <b>nuvem de pontos</b>, <b>modelo 3D</b> e os índices <b>VARI</b> e <b>IFV</b>.",
          ],
        },
      },
      {
        value: PROCESSING_TEMPLATES.PADRAO_3D,
        name: "3D",
        description: {
          titles: [
            "Descrição", "Produtos Gerados",
          ],
          texts: [
            "[<b><u>Versão Beta</u></b>]<br>Tipo de processamento específico para gerar o modelo 3D de alta qualidade. <br><br><b>Restrição:</b> máximo de 500 imagens por projeto.",
            "<b>Modelo 3D</b>, <b>Modelo Digital de Superfície</b>, <b>Nuvem de Pontos</b> e <b>Ortomosaico</b>. <br><br><b>Atenção:</b> os produtos 2D podem ter inconsistências devido ao uso de imagens inclinadas neste tipo de processamento.",
          ],
        },
      },
      
      // {
      //   value: PROCESSING_TEMPLATES.TOPOGRAFIA_RGB,
      //   name: "Topográfico",
      //   description: {
      //     titles: [
      //       "Descrição", "Produtos Gerados",
      //     ],
      //     texts: [
      //       "Processamento voltado para resultados com precisão altimétrica.",
      //       "<b>Ortomosaico</b>, <b>Modelo Digital de Terreno</b>, <b>Modelo Digital de Superfície</b>, <b>Curvas de nível</b>, <b>nuvem de pontos</b> e <b>modelo 3D</b>.",
      //     ],
      //   },
      // },
      {
        value: PROCESSING_TEMPLATES.SILVICULTURA_RGB,
        name: "Florestal",
        description: {
          titles: [
            "Descrição", "Produtos Gerados",
          ],
          texts: [
            "Tipo de processamento para vegetação de porte alto, como silvicultura (Pinus e Eucalipto) e florestas nativas.",
            "<b>Ortomosaico</b>, <b>Modelo Digital de Terreno</b>, <b>Modelo Digital de Superfície</b>, <b>Curvas de nível</b>, <b>nuvem de pontos</b>, <b>modelo 3D</b> e os índices <b>VARI</b> e <b>IFV</b>.",
          ],
        },
      },
    ],
    [CAMERA_TYPES.MULTISPECTRAL]: [
      {
        value: PROCESSING_TEMPLATES.AGRICOLA_MULTISPECTRAL,
        name: "Agrícola",
        description: {
          titles: [
            "Descrição", "Produtos Gerados",
          ],
          texts: [
            "Processamento de imagens obtidas através de <b>sensores multiespectrais</b> em áreas agrícolas. <b>As imagens devem ter formato .TIF</b>.",
            "<b>NDVI</b>, <b>NDRE</b> e <b>SAVI</b> e os <b>mapas de reflectância</b>.",
          ],
        },
      },
    ],
  },
  abGeoreferenceType: {
    [CAMERA_TYPES.RGB]: [
      {
        value: GEOREFERENCE_TYPES.NOT_SET,
        name: "Fotos georreferenciadas",
        description: {
          titles: [
            "Descrição", "Tipo de Arquivo",
          ],
          texts: [
            "Imagens que já estão com coordenadas geográficas inseridas em suas propriedades.",
            "Em geral imagens de <b>multirotores já possuem geotag</b> e essa opção deve ser selecionada.",
          ],
        },
      },
      // {
      //   value: GEOREFERENCE_TYPES.THREE_D_ROBOTICS,
      //   name: "Log de voo",
      //   description: {
      //     titles: [
      //       "Descrição", "Tipo de Arquivo",
      //     ],
      //     texts: [
      //       "Arquivo de log de voo retirado de aeronaves.",
      //       "Inserir o arquivo .log (<b>não confundir com o .bin nem com o .tlog</b>).",
      //     ],
      //   },
      // },
      {
        value: GEOREFERENCE_TYPES.LAT_LONG,
        name: "Log de voo RTK/PPK",
        description: {
          titles: [
            "Descrição", "Tipo de Arquivo",
          ],
          texts: [
            "Para aeronaves que utilizam a tecnologia RTK/PPK deve ser inserido um arquivo .txt com as coordenadas geográficas corretas.",
            "Arquivo <b>.txt</b> respectivamente com <b>latitude, longitude e altitude</b>, com valores separados por <b>\" \" (espaçamento único)</b>. O separador de casa decimal deve ser o <b>\".\" (ponto)</b>. ",
          ],
        },
      },
    ],
    [CAMERA_TYPES.MULTISPECTRAL]: [
      {
        value: GEOREFERENCE_TYPES.NOT_SET,
        name: "Fotos georreferenciadas",
        description: {
          titles: [
            "Descrição", "Tipo de Arquivo",
          ],
          texts: [
            "Imagens que já estão com coordenadas geográficas inseridas em suas propriedades.",
            "Em geral imagens de <b>multirotores já possuem geotag</b> e essa opção deve ser selecionada.",
          ],
        },
      },
    ],
  },
  blGcp: [{
    value: true,
    id: "GCP",
    name: "Usar Pontos de Controle",
    description: {
      titles: [
        "Descrição", "Formato do Arquivo", "Regras de Uso", "Observações"
      ],
      texts: [
        "Os pontos de controle devem ser visíveis, materializados com marcadores coloridos ou em formato de “X” com diâmetro mínimo de "+
        "<b>um metro e meio</b> (1,5m X 1,5m), conforme ilustram as imagens a seguir."+
        "Não são realizados processamentos com pontos de controle obtidos a partir de objetos identificáveis já existentes na área de interesse (esquinas, faixa de pedestres, bueiros, etc)."+
        "<div class='gcp-imgs'>"+
        "<img src='/images/gcp_desc/one.webp'>"+
        "<img src='/images/gcp_desc/two.webp'>"+
        "<img src='/images/gcp_desc/three.webp'>"+
        "<img src='/images/gcp_desc/four.webp'>"+
        "</div>",

        "Arquivo <b>.txt</b> respectivamente com as coordenadas em <b>UTM (Nome, Norte, Leste e Altitude).</b> O separador de casa decimal deve ser o '.' (ponto) e o de colunas deve ser a ',' (vírgula).<br>"+
        "Exemplo de coordenadas UTM:<b> ID1, 856930020, 64575021, 122.123</b><br>"+
        "<img class='coordinates-img' src='/images/gcp_desc/coordinates.webp'>",

        "O processamento com pontos de controle possui o <b>limite de 20 pontos.</b><br /> Observações:",

        "&blacklozenge; Devem ser enviados apenas as coordenadas dos pontos de controle que compõem o processamento enviado, <b>não enviar coordenadas extras</b>, como de pontos de checagem ou de outros voos;<br>" +
        "&blacklozenge; É necessário que as coordenadas estejam no datum WGS 84 ou Sirgas2000;<br>"+
        "&blacklozenge; Os produtos do processamento serão entregues em WGS84/UTM independente do sistema de coordenadas dos pontos de controle inseridos;<br>"+
        "&blacklozenge; As coordenadas enviadas devem estar pós processadas. Erros no arquivo de pontos de controle não serão corrigidos;<br>"+
        "&blacklozenge; As imagens devem estar viradas totalmente para baixo (ângulo de 90 graus) durante o voo, fotos oblíquas não serão processadas;<br>"+
        "&blacklozenge; É de responsabilidade do usuário a qualidade nos dados enviados como das configurações de processamento escolhidas (operação, coleta de pontos de controle, escolha de templates, seleção do EPSG, etc).<br /><br />"+
        "<b>A Mappa não se responsabiliza por problemas na acurácia e precisão dos pontos de controle.</b><br /><br />"+
        "Segue cartilha de boas práticas em mapeamentos com pontos de controle:<br />"+
        "<b>DOWNLOAD:</b> <a target='_blank' href='https://processing-staff.s3.amazonaws.com/FAQ/Boas+pr%C3%A1ticas+em+processamentos+com+pontos+de+controle.pdf'> BOAS PRÁTICAS</a>",
      ],
    },
  }],
}

export const processingTypeToName = (processingType) => {
  return find(PROCESSING_TYPES_DETAILS, "value", processingType).name
}

const processingOptionsTypeToName = (options, value) => {
  return find(options, object => {
    return isEqual(object.value, value)
  }).name
}

export const cameraTypeToName = (cameraType) => {
  return processingOptionsTypeToName(PROCESSING_OPTIONS.abCameraType, cameraType)
}

export const templateTypeToName = (templateType, cameraType) => {
  return processingOptionsTypeToName(PROCESSING_OPTIONS.abProcessingTemplate[cameraType], templateType)
}

export const georeferenceTypeToName = (cameraType, georeferenceType) => {
  return processingOptionsTypeToName(PROCESSING_OPTIONS.abGeoreferenceType[cameraType], georeferenceType)
}

export const PROJECT_SELECTIONS_STATES = {
  NONE: "NONE",
  EXISTING: "EXISTING",
  NEW_PROJECT: "NEW_PROJECT",
}

export const DEFAULT_TILE_TYPE = "mosaic_tiles"

export const AVAILABLE_EPSG = [
  {epsg: "22521", description:	"Corrego Alegre / UTM zone 21S"},
  {epsg: "22522", description:	"Corrego Alegre / UTM zone 22S"},
  {epsg: "22523", description:	"Corrego Alegre / UTM zone 23S"},
  {epsg: "22524", description:	"Corrego Alegre / UTM zone 24S"},
  {epsg: "22525", description:	"Corrego Alegre / UTM zone 25S"},
  {epsg: "29168", description:	"SAD69 / UTM zone 18N"},
  {epsg: "29188", description:	"SAD69 / UTM zone 18S"},
  {epsg: "29169", description:	"SAD69 / UTM zone 19N"},
  {epsg: "29189", description:	"SAD69 / UTM zone 19S"},
  {epsg: "29170", description:	"SAD69 / UTM zone 20N"},
  {epsg: "29190", description:	"SAD69 / UTM zone 20S"},
  {epsg: "29191", description:	"SAD69 / UTM zone 21S"},
  {epsg: "29192", description:	"SAD69 / UTM zone 22S"},
  {epsg: "29193", description:	"SAD69 / UTM zone 23S"},
  {epsg: "29194", description:	"SAD69 / UTM zone 24S"},
  {epsg: "29195", description:	"SAD69 / UTM zone 25S"},
  {epsg: "31972", description:	"SIRGAS 2000 / UTM zone 18N"},
  {epsg: "31978", description:	"SIRGAS 2000 / UTM zone 18S"},
  {epsg: "31973", description:	"SIRGAS 2000 / UTM zone 19N"},
  {epsg: "31979", description:	"SIRGAS 2000 / UTM zone 19S"},
  {epsg: "31974", description:	"SIRGAS 2000 / UTM zone 20N"},
  {epsg: "31980", description:	"SIRGAS 2000 / UTM zone 20S"},
  {epsg: "31981", description:	"SIRGAS 2000 / UTM zone 21S"},
  {epsg: "31982", description:	"SIRGAS 2000 / UTM zone 22S"},
  {epsg: "31983", description:	"SIRGAS 2000 / UTM zone 23S"},
  {epsg: "31984", description:	"SIRGAS 2000 / UTM zone 24S"},
  {epsg: "31985", description:	"SIRGAS 2000 / UTM zone 25S"},
  {epsg: "32618", description:	"WGS 84 / UTM zone 18N"},
  {epsg: "32718", description:	"WGS 84 / UTM zone 18S"},
  {epsg: "32619", description:	"WGS 84 / UTM zone 19N"},
  {epsg: "32719", description:	"WGS 84 / UTM zone 19S"},
  {epsg: "32620", description:	"WGS 84 / UTM zone 20N"},
  {epsg: "32720", description:	"WGS 84 / UTM zone 20S"},
  {epsg: "32721", description:	"WGS 84 / UTM zone 21S"},
  {epsg: "32722", description:	"WGS 84 / UTM zone 22S"},
  {epsg: "32723", description:	"WGS 84 / UTM zone 23S"},
  {epsg: "32724", description:	"WGS 84 / UTM zone 24S"},
  {epsg: "32725", description:	"WGS 84 / UTM zone 25S"},
]

